export const getTrackPath = (url) => {
	// return `${window.location.origin}${url}`;
	return `https://zvukobaza.pro${url}`;
};
